import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_CITIES_OF_SIGMAR: {
    name: 'Battletome: Cities of Sigmar',
    type: 'battletome',
  },
} satisfies TRuleSources

export default rule_sources
